<!--
 * @Description: 用户中心布局
 * @Author: Pancras
 * @Date: 2022-06-27 12:21:45
 * @LastEditors: Adlj
 * @LastEditTime: 2022-10-14 16:19:05
-->
<template>
  <div class="back-container">
    <!-- Header 开始 -->
    <header class="header">
      <div class="top-bar tl-pt-30"
           flex="dir:left main:justify">
        <div class="top-bar-left"
             flex="main:left cross:center">
          <img src="@/assets/index/logo.png">
          <div>
            <div class="top">农业外来入侵物种普查数据库信息平台</div>
            <!-- <div class="bottom">XinJiang Alien Invasive Species Data Center</div> -->
          </div>
        </div>

        <div class="top-bar-right "
             flex="main:left cross:center">
          <div class="labelBtn"
               flex="main:left cross:center">
            <router-link to="/index"
                         active-class="btn1">首页</router-link>

            <router-link to="/species"
                         active-class="btn1">物种名录</router-link>

            <router-link to="/distribute"
                         active-class="btn1">监测预警</router-link>

            <router-link to="/news"
                         active-class="btn1">新闻公告</router-link>
          </div>
          <div>
            <div v-if="!logState"
                 class="logBtn"
                 @click="onLog">
              登录
            </div>
            <div v-if="logState"
                 class="user"
                 flex="main:left cross:center">
              <div class="head">
                <img :src="avatar"
                     alt=""
                     srcset="">
              </div>
              <div class="txt tl-ml-10">
                <span>{{name}}</span>
                <span @click="logout">【退出登录】</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="main-container tl-mt"
         flex>
      <!-- 左侧区域开始 -->
      <div class="left"
           flex="dir:top">
        <!-- 用户基本信息 -->
        <user-info-item></user-info-item>
        <!-- 用户中心菜单 -->
        <menu-item class="tl-mt"></menu-item>
      </div>
      <!-- 左侧区域结束 -->
      <!-- 右侧区域开始 -->
      <div class="right"
           flex="dir:top">
        <router-view></router-view>
      </div>
      <!-- 右侧区域结束 -->
    </div>
    <footer class="tl-mt-30 footer">
      {{setting.webSite.copyright}}<br />
      {{setting.webSite.support}}<br />
      {{setting.webSite.tel}}
    </footer>
  </div>
</template>

<script>
// import FooterItem from '../front/components/FooterItem'
import setting from '@/setting'
import UserInfoItem from './components/UserInfoItem' // 用户基本信息组件
import MenuItem from './components/MenuItem' // 用户中心菜单组件
import { getToken } from '@/libs/auth'
export default {
  name: 'BackendLayout',
  components: {
    // FooterItem,
    UserInfoItem, // 用户基本信息组件
    MenuItem // 用户中心菜单组件
  },
  data () {
    return {
      setting,
      btnState: 0, // 按钮索引
      logState: false, // 登录状态
      title: setting.webSite.title,
      avatar: null,
      name: null,
      baseUrl: setting.server.baseUrl
    }
  },
  mounted () {
    if (getToken()) {
      this.$store.dispatch('GetInfo').then(res => {
        const user = res.user
        const avatar = (user.avatar === '' || user.avatar == null) ? require('@/assets/user.png') : this.baseUrl + user.avatar
        this.avatar = avatar
        this.name = user.nickName
        this.logState = true
      })
    }
  },
  methods: {
    nBtn (state) {
      this.btnState = state
    },
    onLog () {
      this.$router.push('/login')
    },
    async logout () {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          this.$router.push('/')
        })
      }).catch(() => { })
    },
    /**
     * 注册
     */
    handleToReg () {
      this.$router.push('/login?to=reg')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/style/layout/backend.scss";
</style>
